export const create$BackDrop = () => {
  const $BackDrop = document.createElement('div')
  $BackDrop.className = 'BackDrop'
  return $BackDrop
}
